import { render, staticRenderFns } from "./ImportExportManager.vue?vue&type=template&id=2dd556c6&lang=pug"
import script from "./ImportExportManager.vue?vue&type=script&lang=ts"
export * from "./ImportExportManager.vue?vue&type=script&lang=ts"
import style0 from "./ImportExportManager.vue?vue&type=style&index=0&id=2dd556c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports